import { render, staticRenderFns } from "./DefaultDashboardList.vue?vue&type=template&id=7b9b0da4&scoped=true&"
import script from "./DefaultDashboardList.vue?vue&type=script&lang=js&"
export * from "./DefaultDashboardList.vue?vue&type=script&lang=js&"
import style0 from "./DefaultDashboardList.vue?vue&type=style&index=0&id=7b9b0da4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9b0da4",
  null
  
)

export default component.exports